export default "__VITE_ASSET__BCdlv$WT__"